
import "./ToggleSwitchCore/ToggleSwitchCore.st.css.js";
import "./ToggleSwitchCore/ToggleSwitchCoreStyle.st.css.js";
import "./ToggleSwitchCore/ToggleSwitchCoreColor.st.css.js";
import "./ToggleSwitchCore/ToggleSwitchCoreLayout.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_ToggleSwitch";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_ToggleSwitch__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




